import { classNames } from "primereact/utils";
import styles from "./Tag.module.scss";
import React from "react";
import { Tooltip } from "react-tooltip";
import { useSafeId } from "../../tooltip/hooks/useSafeId";
import { RenderWhen } from "../../../infrastructure/components/RenderWhen";
import { calculateTagColors } from "./utils/tagColorUtils";

interface ITagProps {
  className?: string;
  label: string | React.ReactNode;
  color?: string;
  tooltip?: string;
  backgroundColor?: string;
  fontColor?: string;
  removable?: boolean;
  onRemove?: () => void;
  variant?: "default" | "instructor" | "eventType" | "clearAll";
  /** Root element; "span" lets the tag sit inside text, e.g. a <p>. */
  as?: "div" | "span";
}

export const Tag = ({
  className,
  label,
  color,
  tooltip,
  backgroundColor,
  fontColor,
  removable = false,
  onRemove,
  variant = "default",
  as: Root = "div",
}: ITagProps) => {
  const tooltipId = useSafeId();

  if (!label) {
    return;
  }

  const tagStyles = calculateTagColors(
    color,
    backgroundColor,
    fontColor,
    variant
  );
  return (
    <Root
      className={classNames(styles.tag, tooltipId, className)}
      style={tagStyles}
    >
      {label}
      {removable && onRemove && (
        <button
          className={styles.removeButton}
          onClick={onRemove}
          type="button"
          style={{ color: tagStyles.color }}
        >
          ×
        </button>
      )}

      <RenderWhen condition={!!tooltip}>
        <Tooltip
          anchorSelect={`.${tooltipId}`}
          place="top"
          className={styles.root_tooltip}
        >
          <div dangerouslySetInnerHTML={{ __html: tooltip! }} />
        </Tooltip>
      </RenderWhen>
    </Root>
  );
};
